import { z } from 'zod';
import { fromISODate } from '@/utils/date.utils';

import { SecurityPostureScoreSchema } from './securityPosture.entity';

export enum TenantTypeEnum {
  PARTNER = 'partner',
  PARENT = 'parent',
  CHILD = 'child',
}

export const TenantTypeSchema = z.union([z.literal('partner'), z.literal('parent'), z.literal('child')]);
export type TenantType = z.infer<typeof TenantTypeSchema>;

export const TenantTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  snowId: z.string().optional().nullable(),
  shortDescription: z.string().optional().nullable(),
  active: z.boolean().optional().nullable(),
});
export type TenantTag = z.infer<typeof TenantTagSchema>;

export const SoldProductSchema = z.object({
  hasChronicle: z.boolean().optional().nullable(),
  hasSentinelone: z.boolean().optional().nullable(),
  hasCrowdstrike: z.boolean().optional().nullable(),
  hasVulnerabilityManagement: z.boolean().optional().nullable(),
  hasEmailSecurity: z.boolean().optional().nullable(),
  hasSiem: z.boolean().optional().nullable(),
  hasEdr: z.boolean().optional().nullable(),
});

export const TenantSchema = z.object({
  id: z.string().optional(),
  tenantName: z.string(),
  tenantAbbreviation: z.string().nullable(),
  innCode: z.string().optional().nullable(),
  isSecurityPostureSurveyActivated: z.boolean().optional().nullable(),
  isSecurityPostureSurveyCompleted: z.boolean().optional().nullable(),
  snowAccountId: z.string().optional().nullable(),
  securityPostureScore: SecurityPostureScoreSchema.optional().nullable(),
  createdAt: z
    .string()
    .optional()
    .nullable()
    .transform((val: string) => fromISODate(val)),
  modifiedAt: z
    .string()
    .optional()
    .nullable()
    .transform((val: string) => fromISODate(val)),
  tenantType: TenantTypeSchema.optional().nullable(),
  tags: z.array(TenantTagSchema).optional().nullable(),
  parentId: z.string().optional().nullable(),
  soldProducts: SoldProductSchema.optional().nullable(),
  isDhAdminTenant: z.boolean().optional(),
});

export const TenantsSchema = z.array(TenantSchema);

export const TenantListSchema = z.array(TenantSchema);
export type TenantList = z.infer<typeof TenantListSchema>;

export type Tenant = z.infer<typeof TenantSchema>;
export type Tenants = z.infer<typeof TenantsSchema>;
